import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";




import PrivateRoute from "./components/PrivateRoute";
import routes from "./lib/routes";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { AuthProvider } from "./hooks/useAuthProvide";
import { HelpProvider } from "./hooks/useHelpProvide";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2a7bbf",
    },
    secondary: {
      main: "#859ca7",
    },
    background: {
      default: "#f9fafd",
    },
  },
});

function App() {
  return (
    <AuthProvider>
      <HelpProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <Switch>
              {routes.map(({path, Component, needAuth = false}) => {
                if (needAuth) {
                  return (
                    <PrivateRoute key={path} path={path}>
                      <Component />
                    </PrivateRoute>
                  );
                }

                return (
                  <Route key={path} path={path}>
                    <Component />
                  </Route>
                );
              })}
            </Switch>
          </Router>
        </ThemeProvider>
      </HelpProvider>
    </AuthProvider>
  );
}

export default App;
